import {Dropdown} from './dropdown';

export enum Sex {
  MALE = 'Male',
  FEMALE = 'Female',
  UNKNOWN = 'Unknown',
}

const SEX_OPTIONS_FR: Dropdown<Sex>[] = [
  {name: 'Homme', value: Sex.MALE},
  {name: 'Femme', value: Sex.FEMALE},
];

const SEX_OPTIONS_EN: Dropdown<Sex>[] = [
  {name: 'Male', value: Sex.MALE},
  {name: 'Female', value: Sex.FEMALE},
];

export const SEX_OPTIONS = {
  fr: SEX_OPTIONS_FR,
  en: SEX_OPTIONS_EN,
};
